import { LOCALES } from "../locales";

export default {
  [LOCALES.GERMAN]: {
    // general product translation 
    January:"Januar",
    February:"Februar",
    March:"März",
    April:"April",
    May:"Mai",
    June:"Juni",
    July:"Juli",
    August:"August",
    September:"September",
    October:"Oktober",
    November:"November",
    December:"Dezember",
    
    class_policy: "Class Policy",
    Faq: "FAQs",
    help: "Hilfe",
    frequently_asked_ques: "Häufig gestellte Fragen",
    customer_support: "Kundendienst",
    user_name: "Benutzername",
    password: "Passwort",
    email_address: "E-Mail-Adresse",
    december : "Dezember",
    // Header Translations
    notification: "Notification",
    page_loading_aria: "Page is loading",
    state_loading_aria: "State is loading",
    city_loading_aria: "City is loading",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Overall badge",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Certificate image",
    certificate_download: "Download certificate button",
    prev: "Previous",
    log_out: "Abmelden",
    // feature names
    feature_progress: "Fortschritt",
    feature_stressAndIntonation_title:"Betonung und Intonation",
    feature_soundOfEnglish_title:"Englische Laute",
    feature_vocabularyCenter_title: "Vokabelcenter",
    feature_grammarCenter_title:"Grammatikcenter",
    feature_cultureNotes_title: "Kulturelle Besonderheiten",
    feature_globalCommunityTutorials_title:"Global Community Tutorials",
    feature_industryfeed_title: "Industry Feed",    
    feature_newsfeed_title: "News Feed",
    feature_talkWithTeacher_title : "Talk with teacher",
    feature_emailTemplates_title: "E-Mail-Vorlagen",
    feature_accentsAndDialects_title: "Akzente und Dialekte",
    feature_writingCenter_title: "Schreibcenter",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "Info",
    legal: "Impressum",
    privacy_policy: "Datenschutzerklärung",
    Terms_conditions: "Allgemeine Geschäftsbedingungen",
    //button translations
    button_continue: "Weiter",
    button_KnowMore: "Mehr erfahren",
    button_BuyNow: "Jetzt kaufen",
    button_Subscribe: "Abonnieren",
    button_GetStarted: "Los geht's",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "View Details",
    button_ContinueStudying: "Continue",
    button_next: "Weiter",
    button_confirm: "Bestätigen",
    // cookie policy
    common_cookiesPolicyText1: "Learnship verwendet Cookies, um Ihnen den bestmöglichen Service zu gewährleisten. Wenn Sie auf der Seite bleiben stimmen Sie der zu.",
    common_cookiesPolicyText2: "Cookie-Nutzung",
    // EO cookie policy    
    //login-page-translations//
    login_welcome: "Herzlich willkommen,",
    login_heloo: "Hallo!",    
    login_welcome_text: "Fangen wir an.",
    login_log_in: "Anmelden",
    login_errorIncorrectCreds: "Falscher Benutzername oder falsches Passwort.",
    login_errorContactAmin: "Ihr Konto ist inaktiv. Bitte wenden Sie sich an Ihren Administrator.",
    login_errorSSOuser: "Die Anmeldung muss über das Lernportal Ihres Unternehmens erfolgen.",    
    login_forgotPassword: "Passwort vergessen?",
    login_resetPasswordTitle: "Passwort zurücksetzen",
    login_resetSuccess: "Wir haben Ihnen eine E-Mail mit einem Link geschickt, über den Sie Ihr Passwort zurücksetzen können.",
    login_resetFailure: "Falsche E-Mail-Adresse",
    // common translations
    message_errorDefault: "Ein Fehler ist aufgetreten.",
    message_successUpdated: "Updated successfully",
    message_unknownError: "Unknown error",
    message_unAuthorized: "You are unauthorized",
    message_passwordUpdated: "Password updated successfully",
    message_profileUpdated: "Profile updated successfully",
    message_welcomeSubmitted: "Erfolgreich übermittelt",
    message_samepasswordError: "Bitte geben Sie ein neues Passwort ein. Vergewissern Sie sich, dass es sich nicht um ein bereits genutztes Passwort handelt.",
    SAR: "Region auswählen",
    SAL: "Standort auswählen",
    SAT: "Thema auswählen",
    link_readmore: "Mehr erfahren",
    //--//
    profile_title: "Profil",
    profile_nameLabel: "Ich heiße: ",
    profile_countryLabel: "Land",
    profile_stateLabel: "Bundesland",
    profile_cityLabel: "Stadt",
    profile_emailLabel: "E-Mail-Adresse",
    profile_prefContactLabel: "Bevorzugte Kontaktmethode",
    profile_prefSkypeLabel: "Private Skype-ID",
    profile_prefMobileLabel: "Handynummer",
    profile_prefLandlineLabel: "Festnetznummer",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "Ich habe die Nutzungsbedingungen gelesen und bin mit ihnen einverstanden. ",
    profile_continueAria: "Continue button",
    profile_TermsAria: "Ich akzeptiere die Bedingungen.",
    profile_stateTooltip: "Ihre Zeitzone hilft uns dabei, Ihre Online-Sessions zu planen.",
    profile_cityTooltip: "Wenn Sie in keiner der hier gelisteten Städte leben, wählen Sie bitte die nächstgelegene Stadt aus.",
    profile_emailTooltip: "E-Mail-Adresse bestätigen",
    profile_prefTooltip: "All Ihre Sessions finden im virtuellen Klassenraum statt, auch wenn Sie im Onboarding-Prozess eine andere Kontaktmethode angegeben haben. Wir fragen Sie ausschließlich für interne Zwecke nach Ihrer bevorzugten Kontaktmethode, damit wir Ihre Lernerfahrung kontinuierlich verbessern können.",
    profile_fnamePlaceholder: "Vorname",
    profile_lnamePlaceholder: "Nachname",
    profile_countryPlaceholder: "Land auswählen",
    profile_prefContactSelect: "Bevorzugte Kontaktmethode auswählen",
    profile_statePlaceholder: "Bundesland auswählen",
    profile_cityPlaceholder: "Stadt auswählen",
    profile_emailInvalidMessage: "Die E-Mail-Adresse ist ungültig.",
    profile_prefContactPlaceholder: "Bevorzugte Kontaktmethode auswählen",
    profile_prefSkypePlaceholder: "Skype (privat)",
    profile_emailVerifiedChip: "Bestätigt",
    profile_emailVerifyChip: "Bestätigen",
    profile_emailpopup_head: "Bestätigungscode eingeben",
    profile_emailpopup_resendText: "Code erneut senden",
    profile_emailpopup_resendMessage: "Code nicht erhalten?",
    profile_invalidNumber: "Ungültige Nummer",
    profile_prefSkypeAria: "Kontaktaufnahme bevorzugt via Skype (privat)",
    profile_prefMobileAria: "Kontaktaufnahme bevorzugt via Handy",
    profile_prefLandlineAria: "Kontaktaufnahme bevorzugt via Festnetz",
    profile_emailpopup_incorrectCode: "Ungültiger Code",
    profile_editLabel: "Profil bearbeiten",
    profile_editAria: "Bearbeiten",
    profile_mainPasswordPlaceholder: "Passwort hier eingeben",
    profile_updateLabel: "Aktualisieren",
    profile_welcomeJumbotron: "Erzählen Sie uns von sich.",
    profile_cancelLabel: "Abbrechen",
    noAccessl1: "Hoppla! Sie sind nicht berechtigt, diese Seite anzusehen.",
    noAccessl2: "Dieser Link führt Sie zurück zur",
    noAccessl2_1: "Startseite.",
    noAccessl3: "Bitte wenden Sie sich an Ihren Administrator, um Hilfe zu erhalten.",
    profile_changepass_changepassHead: "Passwort ändern",
    profile_changepass_currentpassword: "Aktuelles Passwort",
    profile_changepass_currentpasswordPlaceholder: "Aktuelles Passwort eingeben",
    profile_changepass_newpassword: "Neues Passwort",
    profile_changepass_newpasswordPlaceholder: "Neues Passwort eingeben",
    profile_changepass_confirmnewpassword: "Neues Passwort bestätigen",
    profile_changepass_confirmnewpasswordPlaceholder: "Enter Confirm new password",
    profile_passMustInclude: "Ihr Passwort muss die folgenden Anforderungen erfüllen:",
    profile_passdontmatch: "Die Passwörter stimmen nicht überein.",
    profile_incorrectPassword: "Falsches Passwort",
    profile_passwordSubmit_title: "Passwort eingeben",
    profile_changepass_conditionLength: "8 bis 32 Buchstaben",
    profile_changepass_conditionUppercase: "mindestens ein Großbuchstabe",
    profile_changepass_conditionLowercase: "mindestens ein Kleinbuchstabe",
    profile_changepass_conditionSpecialCharacters: "mindestens eine Zahl oder eines der folgenden Symbole: $!#&@?%*_",
    profile_translationLanguage: "Übersetzungssprache",
    profile_translationLanguagePlaceholder: "Sprache auswählen",
    profile_managerEmailPlaceholder: "E-Mail-Adresse des Managers",
    profile_managerEmailpopupPlaceholder: "Manager’s email address", 
    // Learner Home Page translations
    learnerhome_survey_header: "We need your feedback!",
    learnerhome_survey_line1: "Your company wants to know about your experience using our service.",
    learnerhome_survey_line2: "Please complete our survey by",
    learnerhome_survey_line3: "Your feedback is very important and greatly appreciated.",
    learnerhome_survey_button1: "Take survey",
    learnerhome_survey_button2: "Skip survey",
    active_course: "Aktiver Kurs",
    admin_header: "Administration",
    get_startedText: "Klicken Sie auf einen der Kurse, um loszulegen.",
    product_solo_desc: "Learnship Solo, unser E-Learning-Produkt, bietet Ihnen alles, was Sie benötigen, um Ihre geschäftssprachlichen Kenntnisse im eigenen Tempo zu üben und zu verbessern.",
    product_conversationPractice_desc: "Hier können Sie einzelne Sessions mit Trainern buchen, in denen Fragen gestellt, ein bestimmtes Thema diskutiert oder Rollenspiele durchgeführt werden können. Nützlich für fortgeschrittene Lernende, die ihre Kenntnisse perfektionieren möchten.",
    product_sprint_businessSkills_desc: "Dieses Blended-Learning-Programm der nächsten Generation hilft Ihnen, in Rekordzeit spezifische Geschäftskompetenzen zu entwickeln. Derzeit verfügbar: Geschäftspräsentationen, Geschäftsverhandlungen, Geschäftskorrespondenz und Meetings.",
    product_sprint_levelsProgress_desc: "Unser Blended Learning-Programm der nächsten Generation hilft Ihnen, Ihre Englischkenntnisse innerhalb eines standardisierten Rahmens schnell zu verbessern.",
    product_evolve_relocationLanguage_desc: "Unser Programm für internationale Mitarbeiterentsendungen hilft Ihnen, ein tieferes Verständnis für die Sprache und die sozialen Gepflogenheiten Ihres neuen Aufenthaltslandes zu entwickeln.",
    product_evolve_culturePowerSkills_desc: "Hier entwickeln Sie die interkulturellen Kompetenzen, die Sie benötigen, um in einem internationalen Arbeitsumfeld und in globalen virtuellen Teams erfolgreich zu sein.",
    product_evolve_cultureFocus_desc: "Länderspezifisches Training und kulturelle Intelligenz für Lernende, die ein besseres Verständnis für eine bestimmte Region und ihre Arbeitskultur entwickeln müssen.",
    product_evolve_cultureChange_desc: "Dies ist unser führendes Programm für interkulturelles Geschäftstraining für Expats. Es vermittelt Ihnen ein tiefes Verständnis dafür, was es bedeutet, in einer neuen Kultur zu leben und zu arbeiten.",
    product_elevate_businessSkills_desc: "Kurze, standardisierte Trainingsmodule für Lernende, die spezifische Geschäftskompetenzen wie Präsentieren, Verhandeln oder Teamführung verbessern möchten. Wir bieten auch fachspezifische Kurse an, die sich auf branchenspezifische Terminologie konzentrieren.",
    product_elevate_levelsProgress_desc: "Dieser trainergeführte Kurs für Geschäftssprache hilft Ihnen, Ihre schriftlichen und mündlichen Kompetenzen innerhalb eines standardisierten Rahmens zu verbessern.",
    product_coach_languageCoach_desc: "Kommunizieren Sie in Meetings, in E-Mails, bei Verhandlungen und sogar beim Mittagessen mit Kollegen klar und selbstbewusst. Unser spezifisches Sprachcoaching für Führungskräfte hilft Ihnen, die wichtigsten Geschäftsszenarien zu meistern. Entwickeln Sie Ihre mündlichen, schriftlichen und persönlichen Kommunikationskompetenzen weiter.",
    product_coach_cultureCoach_desc: "Ein zielorientiertes Einzelcoaching-Programm für Führungskräfte, die spezifische interkulturelle Kommunikationsprobleme lösen möchten.",
    product_solo_business_english : "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business English at your own pace.",
    product_solo_business_german :"A multi-level learning program with engaging online exercises to develop your knowledge and application of Business German at your own pace.",
    product_solo_business_french : "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business French at your own pace.",
    product_solo_business_spanish : "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business Spanish at your own pace.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc: "This is your gateway to Dashboard - an intuitive interface that allows administrators to track usage, analyze learner progress, optimize programs and evaluate ROI.",
    product_elevate_desc:"Elevate program Levels Progress our online business language training for learners who want to develop and improve their language skills against a standardized framework.",
    product_lorem_solo_desc: "This rich multimedia program helps your people rapidly improve their English language skills against a standardized framework.",
    //feature translations
    feature_cultureNotes_desc: "Machen Sie sich mit den Kulturen der Regionen vertraut, die für Ihr Geschäfts- und Berufsleben wichtig sind.",
    feature_emailTemplates_desc: "Die E-Mail-Vorlagen decken eine Vielzahl von Geschäftsthemen ab. Wählen Sie die gewünschte Vorlage aus und exportieren Sie sie direkt in Ihren E-Mail-Client, wo Sie sie bearbeiten können.",
    feature_newsFeed_desc: "Willkommen zu unserer revolutionären Lernerfahrung, die internationale Nachrichten mit einbezieht! Lernen Sie Englisch anhand von Berichten und Fragen, die live von unserem Learnship-System generiert werden.",
    feature_talkWithTeacher_desc : "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc: "Der Industry Feed kombiniert eine Bibliothek von branchenspezifischen Artikeln mit KI-gestützten Sprachübungen. Wählen Sie einen Artikel zusammen mit einem Grammatikpunkt aus, den Sie üben möchten.",
    feature_accentsAndDialects_desc:"Explore the richness of global English usage through our library of regional speech samples.",
    feature_stressAndIntonation_desc: "Sorgen Sie dafür, dass Ihr Englisch natürlicher und verständlicher klingt, indem Sie lernen, beim Sprechen die richtige Betonung, den richtigen Rhythmus und die richtige Intonation zu verwenden.",
    feature_soundOfEnglish_desc: "Verbessern Sie Ihre Kommunikationskompetenzen, indem Sie lernen, wie man englische Laute richtig ausspricht.",
    feature_vocabularyCenter_desc: "Ohne Grammatik kann nur wenig vermittelt werden. Ohne Wortschatz kann gar nichts vermittelt werden. - David Wilkins",
    feature_grammarCenter_desc: "Das Grammatikcenter hilft Ihnen, beim Sprechen und Schreiben korrekte Grammatik anzuwenden. Es umfasst Grammatikthemen wie grundlegende Satzteile, Verben und Verbformen sowie Haupt- und Nebensätze.",
    feature_globalCommunityTutorials_desc: "Verbessern Sie Ihre Englischkenntnisse mit dieser wachsenden Sammlung von Lektionen, die von unserer Community entwickelt werden.",
    feature_toeic_desc: "Der TOEIC®-Test ist das von internationalen Unternehmen am häufigsten verwendete Instrument zur Bestimmung der Englischkenntnisse von Mitarbeitern. Der TOEIC® verwendet authentisches schriftliches Material und Dialoge, um Ihre Kenntnisse im Bereich Geschäftsenglisch einzuschätzen.",
    feature_toefl_desc: "TOEFL®, der „Test of English as a Foreign Language“, wird weltweit von Hochschulen und Universitäten, Regierungsbehörden und Stipendienprogrammen zur Bewertung der Englischkenntnisse verwendet.",
    feature_businessSituations_desc: "Das Verzeichnis von Geschäftssituationen macht es Ihnen leicht, bestimmte Übungen zu finden, so dass Sie sich auf die Ausdrücke konzentrieren können, die Sie für die Kommunikation in einer Vielzahl von Geschäftssituationen benötigen.",
    //carousel block translations
    title_feature: "Features",
    we_recommend: "We also recommend",
    // session report translations
    SessionReport_sessionReport: "Sessionbericht",
    SessionReport_sessionDetails: "Details",
    SessionReport_teacherName: "Name des Trainers",
    SessionReport_sessionReview: "Rückblick",
    SessionReport_sessionFeedback: "Feedback zur Session",
    SessionReport_sessionMaterials_Assignments: "Kursmaterialien und Hausaufgaben",
    SessionReport_instructions: "Anweisungen",
    SessionReport_open: "Öffnen",
    SessionReport_invalidSession_Message: "Für diese Session gibt es leider keinen Bericht.",
    SessionReport_rateSession: "Bewerten Sie Ihre Session",
    SessionReport_coachName: "Wie war Ihre Session mit",
    SessionRating_sessionDate: "Datum der Session",
    SessionRating_sessionTime: "Uhrzeit der Session",
    SessionRating_sessionDuration: "Dauer der Session",
    SessionRating_status: "Status",
    SessionRating_rateYourExperience: "Bewerten Sie Ihre Erfahrung",
    SessionRating_whatWentWrong: "Was ist schiefgelaufen?",
    SessionRating_content: "Lehrinhalt",
    SessionRating_technology: "Technik",
    SessionRating_comment: "Kommentar hinzufügen",
    SessionRating_submit: "Senden",
    SessionRating_remindMeLater: "Später erinnern",
    SessionRating_close: "Schließen",
    SessionRating_completed: "Abgeschlossen",
    sessionRating_sessionDetails_mins: "Minuten",

    // my schedule page translations
    myschedule_availability_abty_given:"Wir arbeiten daran, einen passenden Trainer für Sie zu finden.",
        myschedule_schedule:"Mein Terminplan",
        myschedule_availability_needAvl:"Bitte geben Sie Ihre Verfügbarkeit an, damit wir Ihre Session planen können.",
        myschedule_availability_abty_not_given:"Verfügbarkeit angeben / ändern",
        myschedule_statusCard_completed:"Abgeschlossene Session(s)",
        myschedule_statusCard_remaining:"Verbleibende Session(s)",
        myschedule_statusCard_scheduled:"Zu planende Session(s)",
        myschedule_statusCard_lost:"Verlorene Session(s) (zu spät abgesagt oder verpasst)",
        myschedule_recentUpcoming_courseName:"Kursname",
        myschedule_next_session:"Nächste Session",
        myschedule_session_topic:"Thema der Session",
        myschedule_sessionDetails_communication:"Kommunikationsmedium",
        myschedule_sessionDetails_allSessions:"Alle Sessions",
        myschedule_sessionDetails_upcomingSessions:"Bevorstehende Sessions",
        myschedule_sessionDetails_pastSessions:"Vergangene Sessions",
        myschedule_sessionDetails_teacher_name:"Trainer",
        myschedule_sessionDetails_sessions:"Anzahl",
        myschedule_sessionDetails_date :"Datum",
        myschedule_sessionDetails_time :"Uhrzeit",
        myschedule_sessionDetails_durationText:"Dauer",
        myschedule_sessionDetails_min:"Min.",
        myschedule_reschedule_Title:"Eine Session verschieben",
        myschedule_reschedule_InstrBegin:"So können Sie einen neuen Termin für eine Session mit Ihrem Trainer finden:",
        myschedule_reschedule_instr1a:"Details zur Session prüfen",
        myschedule_reschedule_instr1b:"Uhrzeit und Datum Ihrer Session werden oben angezeigt.",
        myschedule_reschedule_instr2:"Neues Zeitfenster finden",
        myschedule_reschedule_instr3:"Sie sehen die Verfügbarkeit Ihres Trainers. Freie Zeitfenster werden in grün angezeigt.",
        myschedule_reschedule_instr4:"Zeitfenster wählen",
        myschedule_reschedule_instr5:"Um Ihren Termin zu verschieben, klicken Sie bitte auf Ihr bevorzugtes Zeitfenster.",
        myschedule_reschedule_next_instr1:"Kein passendes Zeitfenster gefunden",
        myschedule_reschedule_next_instr2:"Versuchen Sie bitte, Ihre Sessions nach Möglichkeit nicht abzusagen. Wenn Sie tatsächlich kein passendes Zeitfenster finden können, klicken Sie bitte auf den Button „KEIN PASSENDES ZEITFENSTER“, um Ihre Session abzusagen. In diesem Fall vereinbart entweder Ihr Trainer einen neuen Termin für diese Session oder ein Administrator hilft Ihnen.",
        myschedule_reschedule_next_instr3:"Trainer wechseln",
        myschedule_reschedule_next_instr4a:"Wenn Sie Ihren Trainer für eine oder mehrere Ihrer verbleibenden Sessions wechseln möchten, schreiben Sie uns bitte über unser",
        myschedule_reschedule_next_instr4b:"Kontaktformular",
        myschedule_reschedule_next_instr4c:"und wählen {productname} und 'Trainer wechseln' aus. Bitte teilen Sie uns mit, aus welchem Grund Sie Ihren Trainer wechseln möchten.",
        myschedule_rechedule_next_info:"Für weitere Informationen zum Verschieben und Absagen von Sessions besuchen Sie bitte unser",
        myschedule_rechedule_next_faq:"FAQ-Portal.",
        myschedule_rechedule_next_noShow:"Diese Infoseite nicht mehr anzeigen",
        myschedule_rechedule_next_done:"Fertig",
        myschedule_rechedule_skipButton:"Überspringen",
        myschedule_upcoming_joinNow:"Jetzt teilnehmen",
        myschedule_cancel_question:"Sind Sie sicher, dass Sie diese Session absagen möchten?",
        myschedule_cancel_button:"Session absagen",
        myschedule_cancel_no:"Nein",
        myschedule_invalid_session:"Das ist leider keine gültige Session.",
        myschedule_sessionDuraion_minutes :"Minuten",
        myschedule_homepage_view :"Anzeigen",
        myschedule_finished_status:"Abgeschlossen",
        myschedule_reschedule_button:"Verschieben",    
    myschedule_no_teacher_title : "Teacher not assigned",
    myschedule_no_teacher_body : "No Sessions can be added at the moment (No teachers assigned). Please contact coach@globalenglish.com to continue with your program.",
    myschedule_no_sessions: "No sessions found",
    myschedule_no_upcoming_sessions: "No upcoming sessions found",
    myschedule_no_past_sessions: "No past sessions found",
    myschedule_status_lost :"Lost",
    myschedule_status_finished:"Finished",
    myschedule_status_completed:"Abgeschlossen",
    myschedule_status_cancelled:"Cancelled",
    myschedule_status_inprogress:"In progress",
    myschedule_status_pending:"Pending",
    myschedule_status_active:"Active",
    myschedule_status_inplanning:"In planning",
    
    // my schedule page translations end
    // Progress page
    progress_title: "Mein Fortschritt",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Reach Skills",
    progress_skill_note: "Sie müssen mindestens 70% der Kursarbeit und Sessions absolvieren, um ein Abschlusszertifikat zu erhalten.",
    progress_overall_card_title_prework:"Vorbereitung abgeschlossen",
    progress_overall_card_title_homework:"Hausaufgaben abgeschlossen",
    progress_overall_card_title_session:"Sessions abgeschlossen",
    progress_overall_card_title_certificate:"Zertifikat",
    progress_overall_card_title_skillsCompleted:"Abgeschlossene Kompetenzen",
    progress_overall_card_title_badgesEarned:"Verdiente Abzeichen",
    progress_overall_card_title_missionsPassed:"Abgeschlossene Missionen",
    progress_overall_card_title_timeInReach:"Zeit in Reach (HH:MM)",
    progress_noSubskill:"Keine Teilkompetenz verfügbar",
    progress_tab_nodata:"Keine Daten verfügbar",
    progress_percentCompleted: "percent completed",
    progress_subskill_preworkTitle: "Vorbereitung",
    progress_subskill_homeworkTitle: "Hausaufgaben",
    progress_subskill_sessionTitle: "Session",
    progress_subskill_sessionStatusCompleted: "Abgeschlossen",
    progress_subskill_sessionStatusNotCompleted: "Nicht abgeschlossen",
    progress_subskill_sessionStatusNoSessions: "Keine Sessions",
    progress_subskill_sessionNoDate:"N/A",    
    progress_activity_tooltip_totaltime: "Gesamtzeit",
    progress_activity_tooltip_activitiesCompleted: "Abgeschlossene Übungen",
    progress_activity_tooltip_reachMissionsCompleted: "Abgeschlossene Missionen in Reach",
    progress_activity_tooltip_timeinhhmm: "Zeit in HH:MM",
    progress_activity_tabDaily:"Täglich",
    progress_activity_tabWeekly:"Wöchentlich",
    progress_activity_tabMonthly:"Monatlich",
    progress_activity_tabQuarterly:"Vierteljährlich",
    progress_activity_tabYearly:"Jährlich",
    progress_acitivity_Minutes: "Minuten",
    progress_acitivity_legend_selfpaced: "Im Selbststudium verbrachte Zeit",
    progress_acitivity_legend_trainerLed: "Mit dem Trainer verbrachte Zeit",
    progress_acitivity_legend_recommended: "Empfohlen",
    progress_testresults_table_testname: "Name des Tests",
    progress_testresults_table_scores: "Ergebnisse",
    progress_testresults_table_date: "Datum",
    progress_testresults_info: "Ihre Testergebnisse sind in 24 Stunden verfügbar.",
    progress_inprogress: "In progress",
    progress_totalscore: "Total score",
    progress_placedText: "Placed",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success : "Downloaded successfully",    
    progress_partText: "Teil",    
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge:"Badge",    
    progress_badge_dialog_box_title: "In order to earn a certificate of completion, we require completion of 70% of the digital exercises.",
    progress_badge_dialog_box_golden : "A success score of 80% earns a gold badge",
    progress_badge_dialog_box_silver : "A success score between 70% and 79% earns a silver badge",
    progress_badge_dialog_box_bronze : "A success score between 50% to 69% earns a bronze badge",
    progerss_badge_dailog_box_digitalActivities : "The success score is calculated based on your performance and engagement with the online digital activities",
    progress_badge_dailog_box_liveSessions : "The success score is calculated based on your performance and engagement with the online digital activities and live sessions",
    
    //EO Progress page
    //email templates
    wcGroup1: "Entschuldigungen",
    wcGroup2: "Beschwerden",
    wcGroup3: "Komplimente",
    wcGroup4: "Beglückwünschungen",
    wcGroup5: "Dokumente",
    wcGroup6: "Einladungen",
    wcGroup7: "Stellenbewerbungen",
    wcGroup8: "Marketing und Verkauf",
    wcGroup9: "Meetings",
    wcGroup10: "Mitteilungen",
    wcGroup11: "Bestellungen",
    wcGroup12: "Preisinformationen",
    wcGroup13: "Bitten, Anfragen",
    wcGroup14: "Danksagungen",
    wcTitle11: "Entschuldigung wegen einer Projektverzögerung",
    wcTitle12: "Entschuldigung wegen eines Buchungsfehlers",
    wcTitle13: "Entschuldigung wegen einer verspäteten Sendung",
    wcTitle14: "Entschuldigung wegen der Zustellung beschädigter Waren",
    wcTitle15: "Entschuldigung wegen eines versäumten Meetings",
    wcTitle21: "Allgemeine Beschwerde",
    wcTitle22: "Beschwerde wegen eines Problems mit einem Produkt",
    wcTitle23: "Beschwerde wegen zu hoher Belastung eines Kontos",
    wcTitle31: "Kompliment an einen Kollegen für ein Projekt",
    wcTitle32: "Kompliment zum Kundenservice",
    wcTitle33: "Kompliment zu einem Produkt",
    wcTitle41: "Glückwünsche zu einer Beförderung (förmlich)",
    wcTitle42: "Glückwünsche zu einer Beförderung (informell)",
    wcTitle43: "Glückwünsche zu einem persönlichen Anlass",
    wcTitle51: "Angefordertes Dokument",
    wcTitle52: "Auftragsformular oder Bestellung",
    wcTitle53: "Rechnung",
    wcTitle61: "Einladung zu einem gesellschaftlichen Anlass",
    wcTitle62: "Einladung zu einer geschäftlichen Veranstaltung",
    wcTitle63: "Eine Einladung annehmen",
    wcTitle64: "Eine Einladung ablehnen",
    wcTitle65: "Eine geschäftliche Veranstaltung absagen",
    wcTitle71: "Bestätigung des Erhalts einer Bewerbung",
    wcTitle81: "Ankündigung eines neuen Produkts",
    wcTitle82: "Bekanntgabe eines neuen regionalen Kundenbetreuers",
    wcTitle83: "Vorführung eines neuen Produkts",
    wcTitle84: "Änderung der Rechnungsanschrift",
    wcTitle85: "Weiterführender Kontakt nach einem ersten Verkaufsgespräch",
    wcTitle86: "Begrüßung neuer Kunden",
    wcTitle87: "Festtagsgruß an Aktionäre oder Kunden",
    wcTitle91: "Einen Termin für ein Gespräch vorschlagen",
    wcTitle92: "Einen Gesprächstermin bestätigen",
    wcTitle93: "Einen Gesprächstermin verschieben",
    wcTitle94: "Einen Gesprächstermin absagen",
    wcTitle95: "Einen Gesprächsinhalt zusammenfassen",
    wcTitle101: "Vorübergehend gesperrtes Konto",
    wcTitle102: "Bitte um Schließung eines Kontos",
    wcTitle111: "Einen Auftrag bestätigen",
    wcTitle112: "Eine Versandbestätigung zustellen",
    wcTitle113: "Einen Auftrag stornieren",
    wcTitle114: "Einen Auftrag ändern",
    wcTitle115: "Eine Lieferung bestätigen",
    wcTitle121: "Preisinformationen zur Verfügung stellen",
    wcTitle122: "Ein Preisangebot annehmen",
    wcTitle123: "Ein Preisangebot ablehnen",
    wcTitle131: "Bitte um Klarstellung",
    wcTitle132: "Bitte um Produktinformationen",
    wcTitle133: "Bitte um Informationen über einen Service",
    wcTitle141: "Allgemeine Danksagungen",
    Blob: "Die Muster-E-Mails decken zahlreiche geschäftliche Themen ab. Wählen Sie eine Muster-E-Mail aus und exportieren Sie sie direkt in Ihren E-Mail-Client, wo Sie sie bearbeiten können.",
    OpenInEmail: "In der E-Mail öffnen",
    Quote1: "Derzeit gibt es weltweit 3,3 Milliarden E-Mail-Konten.",
    Quote1By: "Mashable",
    Quote2: "E-Mails erzielen fast doppelt so hohe Ergebnisse wie Mitteilungen über andere Kanäle.",
    Quote2By: "Direct Marketing Lead",
    Quote3: "Pro Sekunde werden 3,5 Millionen E-Mails versendet.",
    Quote3By: "Marketing Lead",
    SelectACategory: "Kategorie auswählen",
    Title: "E-Mail-Vorlagen",
    WatchTutorial: "Einführungsvideo ansehen",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "Nordamerika",
    Cenam: "Mittelamerika",
    SoAm: "Südamerika",
    EUR: "Europa",
    ASIA: "Asien",
    CenASIA: "Zentralasien",
    SoEASIA: "Südostasien",
    MidEAST: "Naher Osten",
    AFR: "Afrika",
    AUST: "Australien",
    Cana: "Kanada",
    Mexi: "Mexiko",
    Uniteds: "Vereinigte Staaten",
    CostaR: "Costa Rica",
    DomRep: "Dominikanische Republik",
    Guate: "Guatemala",
    Jama: "Jamaika",
    Panam: "Panama",
    TriniTob: "Trinidad und Tobago",
    Arge: "Argentinien",
    Braz: "Brasilien",
    Chil: "Chile",
    Vene: "Venezuela",
    Colomb: "Kolumbien",
    Peru: "Peru",
    Urug: "Uruguay",
    Austria: "Österreich",
    Belg: "Belgien",
    Bulg: "Bulgarien",
    Croatia: "Kroatien",
    Czec: "Tschechische Republik",
    Denm: "Dänemark",
    Finl: "Finnland",
    Fran: "Frankreich",
    Germ: "Deutschland",
    Greec: "Griechenland",
    Hung: "Ungarn",
    Icel: "Island",
    Irel: "Irland",
    Ital: "Italien",
    Lith: "Litauen",
    Luxem: "Luxemburg",
    Neth: "Niederlande",
    Norw: "Norwegen",
    Pola: "Polen",
    Port: "Portugal",
    Roma: "Rumänien",
    Russ: "Russische Föderation",
    Serb: "Serbien",
    Slovakia: "Slowakei",
    Slovania: "Slowenien",
    Spai: "Spanien",
    Swed: "Schweden",
    Swit: "Schweiz",
    Turk: "Türkei",
    Ukra: "Ukraine",
    Unitedk: "Vereinigtes Königreich",
    Chin: "China",
    Hong: "Hongkong",
    Indi: "Indien",
    Japa: "Japan",
    Mongo: "Mongolei",
    Pakis: "Pakistan",
    SoKore: "Südkorea",
    SriLan: "Sri Lanka",
    Taiw: "Taiwan",
    Afgh: "Afghanistan",
    Azer: "Aserbaidschan",
    Kaza: "Kasachstan",
    Camb: "Kambodscha",
    Indo: "Indonesien",
    Malay: "Malaysia",
    Phil: "Philippinen",
    Sing: "Singapur",
    Thai: "Thailand",
    Viet: "Vietnam",
    Bah: "Bahrain",
    Iran: "Iran",
    Iraq: "Irak",
    Isra: "Israel",
    Jor: "Jordanien",
    Kuw: "Kuwait",
    Leb: "Libanon",
    Oma: "Oman",
    Qat: "Katar",
    SauArb: "Saudi-Arabien",
    UAE: "Vereinigte Arabische Emirate",
    Alger: "Algerien",
    Angol: "Angola",
    Egyp: "Ägypten",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenia",
    Malaw: "Malawi",
    Moroc: "Marokko",
    Mozam: "Mosambik",
    Nige: "Nigeria",
    SoAfr: "Südafrika",
    Tanz: "Tansania",
    Ugan: "Uganda",
    Zamb: "Sambia",
    Austra: "Australien",
    NewZea: "Neuseeland",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext: "Machen Sie sich mit den Kulturen der Regionen vertraut, die für Ihr Geschäfts- und Berufsleben wichtig sind.",
    culturenotes_useculturalinfo: "Nutzen Sie unsere kulturellen Informationen, um sich auf wichtige Treffen mit Kunden und Mitarbeitern auf der ganzen Welt vorzubereiten.",
    culturenotes_topicfamiliarize: "Machen Sie sich mit den Sitten und Gebräuchen anderer Kulturen vertraut. Dazu gehören Geschäftszeiten, Restaurantbesuche, Geschenke, uvm.",
    culturenotes_topiclearnculture: "Erfahren Sie mehr über kulturelle Gepflogenheiten und Unterschiede sowie über landesübliche Umgangsformen, um peinliche Fauxpas zu vermeiden.",
    culturenotes_tmaworldtext: "Die Länderberichte stammen von unserem Partner TMA World und stehen als PDF-Download zur Verfügung.",
    culturenoteslocation_viewbytopic: "Nach Thema filtern",
    culturenoteslocation_viewbycountry: "Nach Land filtern",
    dailyNewsFeed_resources: "Resources",
    dailyNewsFeed_daily_News: "Daily News Feed",
    dailyNewsFeed_newsfeedoftheday: "News feed of the day",
    dailyNewsFeed_feedcontent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Sorry, we are unable to fetch daily news feed, please try again after sometime",
    dailyNewsFeed_viewMoreCategories: "VIEW MORE CATEGORIES",
    // Email templates end
    //Error Page Translations
    error_not_found: "Oops! Page not found.",
    error_contact_csm: "Please contact your Customer Success Manager for help.",
    error_under: "Under",
    error_maintenance: "Maintenance",
    error_under_maintenance: "Our site is currently undergoing scheduled maintenance.",
    error_inconvenience: "We're sorry for any inconvenience.",
    error_tryagain: "Please try again later.",
    error_tryagainMins: "Please try again in",
    error_minutes: "minute(s).",
    error_hours : "hour(s)",
    error_oops: "Oops!",
    error_permission_denied: "You don't have permission to View this Page!",
    error_link_home: "home page",
    error_contact_admin: "Please contact your Learnship Administrator for help.",
    error_sorry: "We're Sorry.",
    error_load: "There was a problem loading this Page.",
    error_clear_cache: "Please clear your browser's cache, check your internet connections, and try again.",
    error_contact: "Please contact our",
    error_contact_cst: "customer support team",
    error_forhelp: "for help.",
    error_having_trouble: "Still having trouble?",
    //Accents and Dialects Dropdowns
    AF: "Afrika",
    AS: "Asien",
    AU: "Australien-Ozeanien",
    CA: "Karibik",
    CE: "Mittelamerika",
    EU: "Europa",
    MI: "Nahost",
    NO: "Nordamerika",
    SO: "Südamerika",
    CAMER: "Kamerun",
    EGYPT: "Ägypten",
    ETHIO: "Äthiopien",
    GHANA: "Ghana",
    GUINE: "Guinea",
    NIGER: "Nigeria",
    SOUTH: "Südafrika",
    TANZA: "Tansania",
    AFGHA: "Afghanistan",
    CHINA: "China",
    INDIA: "Indien",
    INDON: "Indonesien",
    JAPAN: "Japan",
    KAZAK: "Kasachstan",
    LEBAN: "Libanon",
    MONGO: "Mongolei",
    NORTH: "Nordvietnam",
    PAKIS: "Pakistan",
    PHILI: "Philippinen",
    SINGA: "Singapur",
    KOREA: "Korea",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwan",
    THAIL: "Thailand",
    TURKM: "Turkmenistan",
    AUSTR: "Australien",
    FIJI_: "Fidschi",
    NEW_Z: "Neuseeland",
    BERMU: "Bermuda",
    CUBA_: "Kuba",
    HAITI: "Haiti",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinique (Französisch)",
    TRINI: "Trinidad und Tobago",
    AUSTRI: "Österreich",
    BELAR: "Weißrussland",
    BELGI: "Bulgarien",
    BULGA: "Bulgaria",
    CYPRU: "Zypern",
    CZECH: "Tschechische Republik",
    DENMA: "Dänemark",
    ENGLA: "England",
    FINLA: "Finnland",
    FRANC: "Frankreich",
    GEORG: "Georgien",
    GERMA: "Deutschland",
    GREEC: "Griechenland-Hellas",
    HUNGA: "Ungarn",
    IRELA: "Irland",
    ITALY: "Italien",
    MACED: "Nordmazedonien",
    NETHE: "Niederlande",
    NORTHI: "Nordirland",
    POLAN: "Polen",
    ROMAN: "Rumänien",
    RUSSI: "Russische Föderation",
    SCOTL: "Schottland",
    SPAIN: "Spanien",
    SWEDE: "Schweden",
    SWITZ: "Schweiz",
    TURKE: "Türkei",
    UKRAI: "Ukraine",
    WALES: "Wales",
    IRAN_: "Iran",
    IRAQ_: "Irak",
    ISRAE: "Israel",
    KUWAI: "Kuwait",
    SAUDI: "Saudi-Arabien",
    SYRIA: "Syrien",
    CANAD: "Kanada",
    MEXIC: "Mexiko",
    ARGEN: "Argentinien",
    BRAZI: "Brasilien",
    CHILE: "Chile",
    COLOM: "Kolumbien",
    PARAG: "Paraguay",
    PERU_: "Peru",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Akzente und Dialekte",
    US:"Vereinigte Staaten von Amerika",
    ALABA:"Alabama",
    ALASK:"Alaska",
    ARKAN:"Arkansas",
    CALIF:"Kalifornien",
    FLORI:"Florida",
    GEORG_US:"Georgia",
    HAWAI:"Hawaii",
    ILLIN:"Illinois",
    INDIA_US:"Indiana",
    KANSA:"Kansas",
    KENTU:"Kentucky",
    LOUIS:"Louisiana",
    MAINE:"Maine",
    MARYL:"Maryland",
    MASSA:"Massachusetts",
    MICHI:"Michigan",
    MINNE:"Minnesota",
    MISSI:"Mississippi",
    MISSO:"Missouri",
    MONTA:"Montana",
    NEBRA:"Nebraska",
    NEW_H:"New Hampshire",
    NEW_J:"New Jersey",
    NEW_Y:"New York",
    NCARO:"North Carolina",
    NDAKO:"North Dakota",
    OHIO_:"Ohio",
    OKLAH:"Oklahoma",
    PENNS:"Pennsylvania",
    SOUTH_US:"South Carolina",
    TENNE:"Tennessee",
    TEXAS:"Texas",
    VIRGI:"Virginia",
    WEST_:"West Virginia",
    WISCO:"Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext: "Your company has requested a monthly report for your manager indicating your progress in Learnship. Please provide your manager’s email address below.",

     // survey and notification
 notification_description_plural : "{days} verbleibende Tage zum Ausfüllen der Umfrage. Sie müssen sie bis {date} abschließen.",
 notification_description_singular : "Sie haben noch 1 Tag, um die Umfrage auszufüllen. Sie müssen sie bis {date} abschließen",
 notification_maintenance_message : "Halo wird am {date} um {time} planmäßig gewartet.",
  //renewal
  renewal_welcome : "Wir freuen uns, Sie wieder bei Learnship begrüßen zu dürfen!",
  renewal_text : "Ihre Learnship-Lizenz läuft am {date}, {month} {year} ab. Verlängern Sie noch heute Ihre Lizenz, wenn Sie Ihre Geschäftsenglisch-Kenntnisse weiter ausbauen möchten. Ihr Lernplan und Ihre gesamten Aktivitäten werden gespeichert und Sie fahren auf Ihrer aktuellen Stufe mit dem Lernmaterial fort.",
  renewal_later : "Zu einem späteren Zeitpunkt erinnern",
  renewal_affirmative : "ich möchte meine Lizenz verlängern.",
  renewal_negative : "ich möchte meine Lizenz nicht verlängern.",
  renewal_yes : "JA",
  renewal_no : "NEIN",
  courselevel: "Course level",
  currentunit: "Current unit",
  upcomingsession: "Upcoming session",
  viewschedule: "View Schedule",
  currentskills: "Skills",
  currentsubskills: "Sub-skills",

  // TWT translations
  twt_talk_with_teacher_title: "Talk with the Teacher",
  twt_sub_heading: "Practice your conversation skills with a teacher and other learners in our online classroom!",
  twt_instructions: "Instructions",
  twt_faq: "FAQs",
  twt_select_sessions: "Select your sessions",
  twt_view_schedule_title: "View schedule and add to calendar",
  twt_next_week: "Next week",
  twt_previous_week: "Previous week",
  twt_add_to_calendar: "Add to calendar",
  twt_view_more: "View more",
  twt_topic: "Topic",
  twt_topic_unavailable: "Topic time not available",
  twt_class_policy: "Klassenrichtlinien",
  twt_class_policy_title: "Richtlinien für 'Mit der Lehrkraft sprechen'",
  twt_class_policy_subHeading: "Die folgenden Richtlinien sind wichtig, um sicherzustellen, dass Ihre Erfahrungen mit TWT (Talk with the Teacher) lehrreich und unterhaltsam ist. Bitte lies sie diese sorgfältig durch.",
  twt_class_policy_list01: "Sie können pro Woche eine online Klasse besuchen. Unsere Online-Klassen haben ein Limit von acht Teilnehmer. Best Practice: TWT-Klassenräume sind immer nur in den ersten 10 Minuten zugänglich. Zum Beispiel ist eine Klasse, die um 9:00 Uhr beginnt, bis 9:10 Uhr zugänglich. Nach den ersten 10 Minuten können Sie der Sitzung nicht beitreten. Begrenzter oder unbegrenzter Zugriff ist abhängig von Ihrer Lizenz",
  twt_class_policy_list02_sub1: "Wenn Sie den Klassenraum betreten, schreiben Sie Ihren Namen, Ihren Wohnort, Land und Ihre derzeitige Lernstufe in das Chat-Feld.",
  twt_class_policy_list02_sub2: `Beispiel: 'Mein Name ist Leo, und ich komme aus Sao Paulo, Brasilien. Ich bin in Stufe 6.`,
  twt_class_policy_list02_sub3: "Der Lehrer aktiviert dann Ihr Mikrofon und das Mikrofonsymbol wird angezeigt.",
  twt_class_policy_list03: "Wenn Sie ein technisches Problem haben, wenden Sie sich an unsere Kundensupport. Klicken Sie oben auf der Seite auf Hilfe um das Problem schriftlich zu melden, oder sprechen Sie mit einem Kundenbetreuer in dem Sie die Chat Schaltfläche rechts unten auf einer beliebigen Seite von Learnship anklicken. Bitte fragen Sie den Lehrer nicht nach technischer Hilfe.",
  twt_class_policy_list04: "Es gibt vier TWT Session Stufen: Anfänger, Mittelstufe, Fortgeschrittene und Alle Stufen. Wählen Sie die Session, die Ihrer aktuellen Stufe und Englischkenntnissen entspricht. Zum Beispiel, wenn Sie in den Stufen 0-3 sind, nehmen Sie an einer Anfänger-Klasse teil. Jeder Teilnehmer (ungeachtet der Stufe) kann an den All-Level-Klassen teilnehmen. Wenn Sie einer TWT-Klasse beitreten, die für Ihre Englischkenntnisse nicht geeignet ist, informiert Sie Ihr Lehrer darüber. Sie haben zwei Möglichkeiten: Sie können dem Lehrer sagen, dass Sie bleiben und nur zuhören möchten, d. H. Sie können nicht aktiv teilnehmen (sprechen); oder Sie können eine andere Klasse zu einer anderen Zeit beitreten.",
  twt_class_policy_list05: "Wenn Sie an einer online Klasse teilnehmen möchten, ohne zu sprechen, können Sie dies jeweils für eine Stunde pro Woche tun. Danach müssen Sie teilnehmen, indem Sie sich während der Klasse aktiv beteiligen und sprechen. Einer Klasse beizutreten und nur zuhören ist für maximal 4 Sessions pro Jahr möglich. Falls Sie sich danach nicht aktiv am Gespräch beteiligen endet Ihre Session.",
  twt_class_policy_point6: "Wir tolerieren keine obszöne oder beleidigende Sprache in Englisch oder in irgendeiner anderen Sprache. Wenn Sie gegen diese Richtlinie verstoßen, werden wir Sie sofort aus der Klasse entfernt, Ihr Manager wird über Ihr beleidigendes Verhalten informiert und wir können Ihr Konto kündigen.",
  twt_class_policy_ok: "Ok",
  twt_max_multi_window_error_message: "You have already joined this session from another device. Please logout before joining from current device.",
  twt_max_capacity_error_message: "Sorry you cannot join this session because it has reached maximum capacity. Please join another session",
  twt_notification_message: "There's a conversation session starting right now. Do you want to join?"
  },
};
